import { __assign } from "tslib";
// DS6.1.2
import React, { useEffect, useState } from 'react';
import c from 'classnames';
import ListCard from '@wix/da-ds/pkg/List/ListCard';
import ListItem from '@wix/da-ds/pkg/List/ListItem';
import { isDropdownGroup } from '../helpers';
import s from './MenuList.scss';
var MenuList = function (_a) {
    var id = _a.id, items = _a.items, _b = _a.itemsFillContainerWidth, itemsFillContainerWidth = _b === void 0 ? false : _b, className = _a.className, ariaLabel = _a.ariaLabel, ariaDescribedby = _a["aria-describedby"];
    var _c = useState(false), mounted = _c[0], setMounted = _c[1];
    useEffect(function () {
        setMounted(true);
    }, []);
    var waitForMount = typeof window === 'undefined' && !mounted;
    if (waitForMount) {
        return null;
    }
    var renderListItem = function (index, props) { return (React.createElement(ListItem, __assign({ key: index }, props, { href: props.link || props.href, fillContainerWidth: itemsFillContainerWidth }))); };
    return (React.createElement(ListCard, { onClick: function (e) { return e.stopPropagation(); }, id: id, className: c(s['root'], !itemsFillContainerWidth && s['content-width'], className), role: "dialog", "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, tabIndex: 0 }, items.map(function (item, index) {
        if (!item) {
            return null;
        }
        if (isDropdownGroup(item)) {
            return (React.createElement("div", { key: index, className: s['group'] }, item.items.map(function (elm, idx) { return elm && renderListItem(idx, elm); })));
        }
        else {
            var singleItem = item;
            return renderListItem(index, singleItem);
        }
    })));
};
MenuList.displayName = 'MenuList';
export default MenuList;
//# sourceMappingURL=MenuList.js.map